// Catalogue de véhicules de luxe — éditable facilement.
// Structure : Catégorie -> Marque -> [Modèles]
export const VEHICLE_CATALOG = {
  "SUV de luxe": {
    "Mercedes-Benz": ["Classe G", "GLS", "GLE", "GLC", "GLE Coupé", "EQS SUV", "EQE SUV"],
    "Mercedes-AMG": ["G 63", "GLE 63", "GLS 63", "GLC 63"],
    "Mercedes-Maybach": ["GLS 600", "G 650 Landaulet"],
    "Rolls-Royce": ["Cullinan", "Cullinan Black Badge"],
    "Bentley": ["Bentayga", "Bentayga EWB", "Bentayga S"],
    "Lamborghini": ["Urus", "Urus S", "Urus SE", "Urus Performante"],
    "Aston Martin": ["DBX", "DBX707"],
    "Ferrari": ["Purosangue"],
    "Range Rover": ["Range Rover", "Sport", "Sport SV", "Autobiography", "Velar", "Evoque"],
    "Land Rover": ["Defender", "Defender 110", "Discovery"],
    "BMW": ["X7", "X7 M60i", "XM", "X5", "X5 M", "X6", "X6 M", "iX"],
    "Audi": ["Q8", "SQ8", "RS Q8", "Q7", "Q8 e-tron"],
    "Porsche": ["Cayenne", "Cayenne Coupé", "Cayenne Turbo GT", "Macan", "Macan Electric"],
    "Maserati": ["Levante", "Grecale"],
    "Lexus": ["LX", "RX", "GX"],
    "Cadillac": ["Escalade", "Escalade-V"],
    "Lotus": ["Eletre"],
    "Tesla": ["Model X", "Model X Plaid"],
  },
  "Berlines de luxe": {
    "Rolls-Royce": ["Phantom", "Ghost", "Ghost Black Badge", "Spectre", "Wraith", "Dawn"],
    "Bentley": ["Flying Spur", "Continental GT", "Continental GTC", "Mulsanne"],
    "Mercedes-Maybach": ["Classe S", "S 680"],
    "Mercedes-Benz": ["Classe S", "Classe E", "Classe C", "CLS", "EQS", "EQE"],
    "Mercedes-AMG": ["Classe S 63", "GT 4 portes", "E 63"],
    "BMW": ["Série 7", "i7", "M760e", "Série 8", "Série 5", "i5"],
    "Audi": ["A8", "S8", "RS7", "A7", "e-tron GT", "RS e-tron GT"],
    "Porsche": ["Panamera", "Taycan", "Taycan Cross Turismo"],
    "Maserati": ["Quattroporte", "Ghibli"],
    "Lexus": ["LS"],
    "Lucid": ["Air"],
    "Tesla": ["Model S"],
  },
  "Vans & MPV VIP (chauffeur)": {
    "Mercedes-Benz": ["Classe V", "Classe V Exclusive", "Vito", "Sprinter VIP", "EQV"],
    "Lexus": ["LM"],
    "Toyota": ["Alphard", "Vellfire"],
    "Volkswagen": ["Multivan", "Caravelle"],
  },
  "Supersportives / GT": {
    "Ferrari": ["Roma", "Portofino M", "296 GTB", "296 GTS", "SF90 Stradale", "12Cilindri", "F8 Tributo"],
    "Lamborghini": ["Huracán", "Temerario", "Revuelto"],
    "Porsche": ["911", "911 GT3", "911 Turbo S", "718 Cayman", "718 Boxster"],
    "McLaren": ["GT", "720S", "750S", "Artura", "765LT"],
    "Aston Martin": ["DB12", "Vantage", "DBS", "Vanquish"],
    "Bentley": ["Continental GT Speed"],
    "Maserati": ["MC20", "GranTurismo"],
    "Mercedes-AMG": ["GT", "SL"],
    "BMW": ["M4", "M8"],
    "Lotus": ["Emira"],
    "Alfa Romeo": ["4C"],
    "Tesla": ["Model S Plaid"],
  },
  "Hypercars / exotiques": {
    "Bugatti": ["Chiron", "Veyron", "Tourbillon", "Divo", "Centodieci", "Mistral"],
    "Koenigsegg": ["Jesko", "Gemera", "Regera", "Agera"],
    "Pagani": ["Huayra", "Utopia", "Zonda"],
    "Ferrari (série limitée)": ["LaFerrari", "Daytona SP3", "Monza SP1", "Monza SP2"],
    "Lamborghini (série limitée)": ["Aventador", "Sián", "Reventón", "Veneno", "Countach LPI 800-4"],
    "McLaren (série limitée)": ["P1", "Senna", "Speedtail"],
    "Aston Martin (série limitée)": ["Valkyrie", "Valhalla"],
    "Rimac": ["Nevera"],
    "Mercedes-AMG": ["One"],
  },
  "Classiques / collection": {
    "Ferrari": ["250 GTO", "Daytona", "Testarossa", "F40", "F50", "288 GTO"],
    "Lamborghini": ["Miura", "Countach", "Diablo"],
    "Porsche": ["356", "911 Carrera RS 2.7", "959"],
    "Jaguar": ["Type E", "XKSS"],
    "Mercedes-Benz": ["300 SL Gullwing", "600 Pullman"],
    "Rolls-Royce": ["Silver Ghost", "Silver Cloud", "Phantom I", "Phantom II", "Phantom III"],
    "Bentley": ["R-Type Continental", "Blower Bentley"],
    "Aston Martin": ["DB5", "DB4", "DB6"],
    "Bugatti": ["Type 35", "Type 41 Royale", "Type 57"],
    "Maserati": ["Ghibli 1re génération", "Bora"],
    "Alfa Romeo": ["8C 2900"],
    "Duesenberg": ["Model J"],
  },
};

export const OTHER = "Autre";

export function findCategory(brand, model) {
  if (!brand) return null;
  if (model) {
    for (const [category, brands] of Object.entries(VEHICLE_CATALOG)) {
      if ((brands[brand] || []).includes(model)) return category;
    }
  }
  for (const [category, brands] of Object.entries(VEHICLE_CATALOG)) {
    if (brands[brand]) return category;
  }
  return null;
}
